import React, { useState, useEffect } from 'react';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonBackButton,
  IonButtons,
  IonButton,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardSubtitle,
  IonCardContent,
  IonList,
  IonItem,
  IonLabel,
  IonSpinner,
  IonText,
  IonNote,
  IonListHeader,
  IonChip
} from '@ionic/react';
import { useParams, useHistory } from 'react-router-dom';
import Footer from '../components/Footer';
// No es estrictamente necesario un CSS si aplicamos estilos inline o en global.css
// import './TicketDetail.css';

// const PHP_PROXY_URL_HOME_SECTIONS = 'https://portal.mastinseguridad.com/apisapp/ga_proxy.php';

// const getOrCreateGaClientIdForHome = (): string => {
//   let clientId = localStorage.getItem('ga_client_id');
//   if (!clientId) {
//     clientId = typeof self !== 'undefined' && self.crypto?.randomUUID ? 
//                self.crypto.randomUUID() : 
//                `uuid-${Date.now()}-${Math.random().toString(36).substring(2)}`;
//     localStorage.setItem('ga_client_id', clientId);
//   }
//   return clientId;
// };

// const user = localStorage.getItem('profile') as string;
// const profile = user ? JSON.parse(user) : null;
// const userIdForGa = profile?.id?.toString() ?? undefined; 

// const clientIdForGa = getOrCreateGaClientIdForHome();

// const payloadToProxyHome = {
//   client_id: clientIdForGa,
//   user_id: userIdForGa, 
//   event_name: 'page_view', 
//   event_params: {         
//       page_location: '/pages/TicketDetail',
//       page_title: 'TicketDetail'
//   }
// };

// console.log('Enviando page_view inicial a proxy GA:', payloadToProxyHome);
// fetch(PHP_PROXY_URL_HOME_SECTIONS, {
//   method: 'POST',
//   headers: { 'Content-Type': 'application/json' },
//   body: JSON.stringify(payloadToProxyHome)
// })
// .then(response => {
//   if (!response.ok) {
//     response.json().then(err => console.error('Error desde proxy GA (page_view):', err)).catch(() => console.error('Error desde proxy GA (Home page_view), respuesta no JSON'));
//   } else {
//     response.json().then(data => console.log('Éxito vía proxy GA (page_view):', data)).catch(() => console.log('Éxito vía proxy GA (Home page_view), respuesta no JSON'));
//   }
// })
// .catch(error => {
//   console.error('Error de red contactando proxy GA (page_view):', error);
// }); 

interface props {
  netState: boolean;
}

interface TicketDetails {
  id: string;
  properties: {
    subject: string;
    content: string;
    createdate: string;
    hs_pipeline_stage: string;
  };
}

interface TicketNote {
    id: string;
    properties: {
        hs_note_body: string;
        hs_createdate: string;
        hubspot_owner_id?: string;
    };
}

interface TicketDetailResponse {
    ticket: TicketDetails;
    notes: TicketNote[];
}

const ticketStatusMap: { [key: string]: string } = {
  '1': 'Nuevo',
  '2': 'Esperando al contacto',
  '3': 'Esperando acción por nuestra parte',
  '4': 'Cerrado'
  // ...otros estados
};

const TicketDetail: React.FC<props> = ({ netState }) => {
  const { id: ticketId } = useParams<{ id: string }>();
  const history = useHistory();
  const [ticketData, setTicketData] = useState<TicketDetailResponse | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchTicketDetails = async () => {
      if (!ticketId) {
        setError("No se especificó un ID de ticket.");
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      setError(null);

      try {
        const backendUrl = `https://biinyugames.com/mastinpqrs/get_ticket_detail.php?id=${ticketId}`;
        const response = await fetch(backendUrl);

        if (!response.ok) {
          let errorMsg = `Error ${response.status}: No se pudieron cargar los detalles del ticket.`;
           try {
             const errorData = await response.json();
             if (errorData && errorData.error) errorMsg = errorData.error;
           } catch (e) {}
          throw new Error(errorMsg);
        }

        const data: TicketDetailResponse = await response.json();
        setTicketData(data);

      } catch (err: any) {
        console.error("Error al cargar detalles del ticket:", err);
        setError(err.message || "Ocurrió un error desconocido.");
      } finally {
        setIsLoading(false);
      }
    };

    if (netState) {
      fetchTicketDetails();
    } else {
      setError("Sin conexión a internet.");
      setIsLoading(false);
    }

  }, [ticketId, netState]);

  const getReadableStatus = (stageId: string): string => {
    return ticketStatusMap[stageId] || stageId;
  }

  const formatDate = (dateString: string | undefined) => {
      if (!dateString) return 'Fecha desconocida';
      try {
          return new Date(dateString).toLocaleString();
      } catch (e) {
          return dateString;
      }
  }

  // Estilos para aplicar al contenedor del mensaje original y las notas
  const preWrapStyle: React.CSSProperties = {
      whiteSpace: 'pre-wrap', // Conserva espacios/saltos de línea y ajusta el texto
      wordWrap: 'break-word',  // Rompe palabras largas si es necesario
      fontFamily: 'inherit',   // Usa la fuente normal de la app
      margin: '0',             // Quita márgenes por defecto si se usa <pre>
      padding: '8px 0',        // Añade algo de padding vertical
  };

  const noteContentStyle: React.CSSProperties = {
    fontSize: '0.9em',       // Hacer las notas un poco más pequeñas
    width: '100%',           // Asegurar que ocupe el ancho
  }


  if (isLoading) {
    return (
      <IonPage>
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonBackButton defaultHref="/pqrs" />
            </IonButtons>
            <IonTitle>Cargando Ticket...</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent className="ion-padding ion-text-center">
          <IonSpinner />
        </IonContent>
      </IonPage>
    );
  }

  if (error) {
    return (
       <IonPage>
         <IonHeader>
           <IonToolbar>
             <IonButtons slot="start">
               <IonBackButton defaultHref="/pqrs" />
             </IonButtons>
             <IonTitle>Error</IonTitle>
           </IonToolbar>
         </IonHeader>
         <IonContent className="ion-padding">
            <IonText color="danger">{error}</IonText>
            <IonButton expand="block" onClick={() => history.goBack()} className="ion-margin-top">Volver</IonButton>
         </IonContent>
       </IonPage>
     );
  }

  if (!ticketData?.ticket) {
      return (
         <IonPage>
           <IonHeader>
             <IonToolbar>
               <IonButtons slot="start">
                 <IonBackButton defaultHref="/pqrs" />
               </IonButtons>
               <IonTitle>Ticket no encontrado</IonTitle>
             </IonToolbar>
           </IonHeader>
           <IonContent className="ion-padding">
              <IonText>No se encontró la información para este ticket.</IonText>
              <IonButton expand="block" onClick={() => history.push('/pqrs')} className="ion-margin-top">Ir al listado</IonButton>
           </IonContent>
         </IonPage>
       );
    }


  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/pqrs" />
          </IonButtons>
          <IonTitle>Detalle Ticket #{ticketId}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent className="ion-padding ticket-detail-content">
        <IonCard>
          <IonCardHeader>
             <IonCardTitle>{ticketData.ticket.properties.subject || 'Sin Asunto'}</IonCardTitle>
             <IonCardSubtitle>
                Creado: {formatDate(ticketData.ticket.properties.createdate)}
             </IonCardSubtitle>
              <IonChip outline={true} color="primary">
                  <IonLabel>{getReadableStatus(ticketData.ticket.properties.hs_pipeline_stage)}</IonLabel>
              </IonChip>
          </IonCardHeader>
          <IonCardContent>
            <IonLabel position="stacked">Mensaje Original:</IonLabel>
            {/* Usamos un div con estilos para asegurar el ajuste de texto */}
            <div style={preWrapStyle}>
                {ticketData.ticket.properties.content || 'No hay contenido.'}
            </div>
          </IonCardContent>
        </IonCard>


        <IonListHeader>
            <IonLabel>Historial / Notas</IonLabel>
        </IonListHeader>
        {ticketData.notes && ticketData.notes.length > 0 ? (
          <IonList lines="full">
            {ticketData.notes.sort((a, b) => new Date(b.properties.hs_createdate).getTime() - new Date(a.properties.hs_createdate).getTime())
              .map((note) => (
              <IonItem key={note.id}>
                <IonLabel className="ion-text-wrap">
                   {/* Renderizar el HTML de la nota de forma segura */}
                   {/* Usamos dangerouslySetInnerHTML para interpretar el HTML de la nota */}
                   {/* ¡IMPORTANTE! Asegúrate de confiar en el origen del HTML (HubSpot en este caso) */}
                   {/* o considera usar una librería de sanitización como DOMPurify si necesitas más seguridad */}
                   <div
                       style={noteContentStyle}
                       dangerouslySetInnerHTML={{ __html: note.properties.hs_note_body }}
                   />
                  <IonNote slot="end" style={{ textAlign: 'right', width: '100%', display: 'block', marginTop: '8px' }}>
                    {formatDate(note.properties.hs_createdate)}
                  </IonNote>
                </IonLabel>
              </IonItem>
            ))}
          </IonList>
        ) : (
          <IonItem lines="none">
            <IonLabel>No hay notas asociadas a este ticket.</IonLabel>
          </IonItem>
        )}

      </IonContent>
      <Footer />
    </IonPage>
  );
};

export default TicketDetail;